import { OrderStatus, ORDER_STATUSES } from "@goodfill/domain-properties";
import { OrderStatusComponent } from "@goodfill/domain-properties-components";
import {
  MultiselectCriteria,
  multiselectFilter,
  MultiselectFilterChangeFunction,
  MultiselectColumnDefinition,
} from "../generic/MultiselectColumnDefinition";

export const ORDER_STATUS_CRITERIA_KEY = "orderStatuses";

export const orderStatusFilter = <TItemKey extends string>(key: TItemKey) =>
  multiselectFilter(ORDER_STATUS_CRITERIA_KEY, key);

export const OrderStatusColumnDefinition = <TItemKey extends string>(
  itemKey: TItemKey,
  criteria: MultiselectCriteria<typeof ORDER_STATUS_CRITERIA_KEY, OrderStatus>,
  onFilterChange: MultiselectFilterChangeFunction<typeof ORDER_STATUS_CRITERIA_KEY, OrderStatus>,
) =>
  MultiselectColumnDefinition(
    "Status",
    itemKey,
    ORDER_STATUS_CRITERIA_KEY,
    criteria,
    onFilterChange,
    ORDER_STATUSES,
    (a: OrderStatus) => `${a}`,
    (a: string) => a as OrderStatus,
    250,
    (a) => <OrderStatusComponent value={a[itemKey]} />,
  );
